import { useFeatureToggle } from './useFeatureToggle'

// The Arc manager dashboard (/app/manager/dashboard) is gated on the same
// per-school flag the backend uses to redirect managers there
// (SchoolManagement::DashboardController). Requiring the full three-flag
// rollout set locked out every self-signup Arc school, which are created
// with only arc-mosaico-project in schools.features.
export const ARC_MANAGER_DASHBOARD_FLAGS = ['arc-mosaico-project'] as const

export const useArcManagerDashboardEnabled = (): boolean => {
  return useFeatureToggle('arc-mosaico-project') as boolean
}
